import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Tours from './pages/Tours';
import TourDetail from './pages/TourDetail';
import Categories from './pages/Categories';
import Villas from './pages/Villas';
import Contact from './pages/Contact';

// Admin components
import AdminLogin from './pages/admin/Login';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import AdminTours from './pages/admin/Tours';
import AdminBookings from './pages/admin/Bookings';
import AdminContactsPage from './pages/admin/Contacts';
import AdminNewsletter from './pages/admin/Newsletter';
import AdminCategories from './pages/admin/Categories';
import AdminVillas from './pages/admin/Villas';
import AdminCommunication from './pages/admin/Communication';
import AdminEmailSettings from './pages/admin/EmailSettings';
import AdminSiteSettings from './pages/admin/SiteSettings';
import AdminSecurity from './pages/admin/Security';
import ChangePassword from './pages/admin/ChangePassword';

import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/tours" element={<Tours />} />
        <Route path="/tours/:id" element={<TourDetail />} />
        <Route path="/categories" element={<Categories />} />
        <Route path="/villas" element={<Villas />} />
        <Route path="/contact" element={<Contact />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/change-password" element={<ChangePassword />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="tours" element={<AdminTours />} />
          <Route path="bookings" element={<AdminBookings />} />
          <Route path="contacts" element={<AdminContactsPage />} />
          <Route path="newsletter" element={<AdminNewsletter />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="villas" element={<AdminVillas />} />
          <Route path="communication" element={<AdminCommunication />} />
          <Route path="email-settings" element={<AdminEmailSettings />} />
          <Route path="site-settings" element={<AdminSiteSettings />} />
          <Route path="security" element={<AdminSecurity />} />
        </Route>
      </Routes>
    </Router>
  );
}

// Error boundary for debugging
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (e) => {
    console.error('Global error:', e.error);
  });

  window.addEventListener('unhandledrejection', (e) => {
    console.error('Unhandled promise rejection:', e.reason);
  });
}

export default App;

